import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AgentChat from "./AgentChat";

export interface AgentModalProps {
  open: boolean;
  onClose: () => void;
  /** Display name of the agent. */
  name: string;
  /** Websocket to connect to: Rocket proxy URL, or a direct sidecar (island). */
  wsUrl: string;
  /** Only for direct sidecar connections; omitted through the proxy. */
  repoPath?: string;
  allowedTools?: string[];
}

/**
 * Modal housing the Claude interface for a single agent. Kept presentational so
 * it can be opened standalone (the "island" test) or from the BACKGROUND panel.
 */
export default function AgentModal({
  open,
  onClose,
  name,
  wsUrl,
  repoPath,
  allowedTools,
}: AgentModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { height: "80vh" } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 1 }}>
        <Box sx={{ flex: 1 }}>{name}</Box>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
        {/* Remount the chat (and its socket) each time the modal opens. */}
        {open && <AgentChat wsUrl={wsUrl} repoPath={repoPath} allowedTools={allowedTools} />}
      </DialogContent>
    </Dialog>
  );
}
